import React from "react";
import event2 from "../static/img/Resilience Summit Event Poster.jpg";
import arrow from "../static/img/down_arrow.svg";
import "../static/css/Event1.css";
import Resilienceimagesvg from "../static/img/Resilience Web page (2).jpg";

const Event1 = () => {
  const handleBrochureDownload = () => {
    const pdfUrl = `${process.env.PUBLIC_URL}/files/The Resilience Summit Agenda.pdf`;

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "The Resilience Summit Agenda.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.open(pdfUrl, "_blank");
  };

  return (
    <div className="event1">
      <div className="event1-container">
        <div className="event1-content">
          <div className="event1-content1">
            <p>Optimizing Today, Resilient for Tomorrow</p>
          </div>
          <div className="event1-content2">Resilience Summit</div>
          <div className="event1-content3">
            Building Resilient Supply Chains & Systems: Strategies to implement from procurement to delivery
          </div>
          <div className="event1-content4">
            <div className="event1-play">
              <p></p>
            </div>
            <div className="event1-play-content">
              Get to know about Virtual Event
            </div>
            <div className="event1-play-button">
              <button onClick={handleBrochureDownload}>
                <img src={arrow} alt="Down Arrow" />
                Download Event Agenda 
              </button>
            </div>
          </div>
        </div>
        <div className="event1-img">
          <img src={event2} alt="Synergy Summit" />
        </div>
      </div>
      <div className="event1-svg">
          <img src={Resilienceimagesvg} alt="Event SVG" />
      </div>
    </div>
  );
};

export default Event1;
